import { uiSize } from '@utils'

interface Props {
  color?: string
}

function ChevronDownIcon({ color = 'var(--banky-black)' }: Props) {
  return (
    <svg width={uiSize(12)} height={uiSize(7)} viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M1 1L6 6L11 1' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}

export default ChevronDownIcon
